module.exports = __webpack_public_path__ + "img/process.10343331.png";